const WebflowSimulator = () => {
  const industries = [
    {
      name: "ES Autonomo Test (only for developement!)",
      // description: "For micro, small and medium-sized enterprises",
      description: "Para micro, pequeñas y medianas empresas",
      landingUrl: "https://vallalkozas.bookkeepie.com/es/es-autonomo-1",
      useExternal: true,
    },
    {
      name: "Autonomo Espana Ecom Basic",
      // description: "For micro, small and medium-sized enterprises",
      description: "Para micro, pequeñas y medianas empresas",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/autonomo-espana-ecom-basic",
      useExternal: true,
    },
    {
      name: "Autonomo Espana Ecom Medium",
      // description: "For growing small and medium-sized e-commerce businesses",
      description: "Para pymes de comercio electrónico en crecimiento",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/autonomo-espana-ecom-medium",
      useExternal: true,
    },
    {
      name: "Autonomo Espana Ecom High",
      // description: "For established e-commerce businesses with higher needs",
      description:
        "Para empresas de comercio electrónico consolidadas con mayores necesidades",
      landingUrl:
        "https://vallalkozas.bookkeepie.com/autonomo-espana-ecom-high",
      useExternal: true,
    },
  ];

  const handleClick = (industry) => {
    if (industry.landingUrl) {
      window.open(industry.landingUrl, "_blank");
    }
  };

  return (
    <div
      style={{
        maxWidth: 900,
        width: "100%",
        margin: "24px auto",
        padding: "24px 16px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        boxSizing: "border-box",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: 16, fontSize: 32 }}>
        Webflow Simulator
      </h1>
      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: 48,
          fontSize: 16,
        }}
      >
        Temporary page to simulate Webflow CTAs. Choose an industry to see the
        HubSpot form:
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))",
          justifyItems: "stretch",
          gap: 24,
        }}
      >
        {industries.map((industry, idx) => (
          <div
            key={idx}
            style={{
              width: "100%",
              maxWidth: "100%",
              border: "2px solid #e0e0e0",
              borderRadius: 12,
              padding: 24,
              background: industry.name?.startsWith("ES Autonomo Test")
                ? "#faffdf"
                : "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "all 0.2s",
              cursor: "pointer",
              boxSizing: "border-box",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#1c32f3";
              e.currentTarget.style.boxShadow =
                "0 4px 16px rgba(28,50,243,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e0e0e0";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
            }}
            onClick={() => handleClick(industry)}
          >
            <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: 20 }}>
              {industry.name}
            </h2>
            <p style={{ color: "#666", marginBottom: 16, fontSize: 14 }}>
              {industry.description}
            </p>
            <div
              style={{
                fontSize: 12,
                color: "#1c32f3",
                fontFamily: "monospace",
              }}
            >
              🔗 {industry.landingUrl}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebflowSimulator;
